<template >
  <div class="mainbody">
    <div class="tableInfo">
      <div class="filter">
        <div class="wrap">
          <div class="label">校友名称：</div>
          <el-input
            @keyup.enter.native="$query()"
            size="medium"
            v-model="inputing.where_name"
            placeholder="请输入"
          ></el-input>
        </div>
        <div class="wrap">
          <div class="label">校友学号：</div>
          <el-input
            @keyup.enter.native="$query()"
            size="medium"
            v-model="inputing.where_student_no"
            placeholder="请输入"
          ></el-input>
        </div>
        <div class="btn-group">
          <div class="search-btn"></div>
          <el-button size="small" @click="$query()" type="primary"
            >查询</el-button
          >
          <el-button size="small" @click="$reset()">重置</el-button>
        </div>
      </div>
      <div style="padding: 16px 32px 16px 0px">
        <span class="title" @click="downloadAll()">下载头像</span>
        <span
          class="title"
          style="float: right; margin-right: 0px; padding: 0"
          @click="modifyStyle()"
          >图片上传样式更改</span
        >
        <img
          src="@/assets/icon_upload.png"
          style="float: right; margin-right: 5px; margin-top: 2px"
        />
        <span
          class="title"
          style="float: right; margin-right: 20px; padding: 0"
          @click="exportPhoto()"
          >一键导出列表</span
        >
        <img
          src="@/assets/icon_export.png"
          style="float: right; margin-right: 5px; margin-top: 2px"
        />
      </div>
      <div class="aLine"></div>
      <!-- <el-table :data="data_list" @filter-change="filterChange" @row-click="showInfo" @selection-change="handleSelectionChange"> -->
      <el-table
        :data="data_list"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <el-table-column type="selection" min-width="1"></el-table-column>
        <el-table-column
          sortable="custom"
          prop="student_no"
          label="学号"
          min-width="1"
        ></el-table-column>
        <el-table-column
          sortable="custom"
          prop="name"
          label="姓名"
          min-width="1"
        ></el-table-column>
        <el-table-column label="头像" min-width="1">
          <template slot-scope="scope">
            <el-image
              style="cursor: pointer; width: 60px; height: 82px"
              :src="urlPath + scope.row.img_link"
              fit="cover"
              :preview-src-list="[urlPath + scope.row.img_link]"
            >
              <div
                slot="error"
                class="image-slot"
                style="position: absolute; top: 50%; left: 50%"
              >
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="提交时间"
          min-width="1"
        ></el-table-column>
        <!-- <el-table-column prop="status" label="审核状态" min-width="1" :filters="optionsExamine" filter-placement="bottom-end" column-key="filterResult"></el-table-column> -->
        <el-table-column
          prop="status"
          label="审核状态"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="operating"
          label="操作"
          min-width="1"
          align="left"
        >
          <template slot-scope="scope">
            <el-button
              class="operateText"
              size="mini"
              type="text"
              @click="download(scope.row)"
              >下载图片</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>
    <PhotoExamineDialog
      ref="_photoExamineDialog"
      @saveData="examineAlumniPhoto"
    ></PhotoExamineDialog>
    <PhotoExamineStyleDialog
      ref="_photoExamineStyleDialog"
    ></PhotoExamineStyleDialog>
    <ExportUserPhotoDialog ref="_exportUserPhotoDialog"></ExportUserPhotoDialog>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Utils from "@/utils/utils.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as Constant from "@/utils/constant.js";
import PhotoExamineDialog from "@/components/dialog/photoExamineDialog";
import PhotoExamineStyleDialog from "@/components/dialog/photoExamineStyleDialog";
import ExportUserPhotoDialog from "@/components/dialog/exportUserPhotoDialog";

export default {
  components: {
    PhotoExamineDialog,
    PhotoExamineStyleDialog,
    ExportUserPhotoDialog,
  },
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      optionsExamine: Constant.options_state_examine,
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      selection: [],
      inputing: { where_name: "", where_student_no: "" },
      filter: { where_name: "", where_student_no: "" },
    };
  },
  created() {
    this.getList();
    this.$root.$on("refreshPhoto", () => {
      this.getList();
    });
  },
  activated() {
    this.$reset();
  },
  beforeDestroy() {
    this.$root.$off("refreshPhoto");
  },
  methods: {
    getList: function (order) {
      let params = {
        token: localStorage.getItem("token"),
        page: this.currentPage,
        limit: this.pageMaxSize,
      };
      if (this.filter.where_name != "") {
        params["where_name"] = this.filter.where_name;
      }
      if (this.filter.where_student_no != "") {
        params["where_student_no"] = this.filter.where_student_no;
      }
      if (order) {
        params["order"] = order;
      }
      this.$api
        .alumniNewPhotoList(params)
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage);
          if (current_page) {
            this.currentPage = current_page;
            this.getList();
          }
          this.pageCount = data.Data.pageCount;
          this.data_list = data.Data.model;
          this.data_list.forEach((info) => {
            this.optionsExamine.forEach((examin) => {
              if (info.status == examin.value) info.status = examin.text;
            });
            info.updateTime = Utils.dateFormat(info.update_time * 1000);
          });
        })
        .catch(({ error }) => {});
    },
    // 过滤
    filterChange(filters) {
      this.screen_result = StrUtils.getStr4List1(filters.filterResult);
      if (this.screen_result == "") this.screen_result = undefined;
      this.getList();
    },
    currentChange(val) {
      this.elementui_page_key++;
      this.currentPage = val;
      this.getList();
    },
    // 列表选中监听
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    selectionEmpty() {
      if (this.selection.length == 0) {
        this.$message.error("至少选中一条数据");
        return true;
      }
      return false;
    },
    downloadAll() {
      if (this.selectionEmpty()) return;
      let log_ids = [];
      this.selection.forEach((info) => {
        log_ids.push(info.log_id);
      });
      this.$nextTick(() => {
        this.$refs._exportUserPhotoDialog.show(log_ids);
      });
    },
    exportPhoto() {
      if (this.data_list.length > 0) {
        this.$nextTick(() => {
          this.$refs._exportUserPhotoDialog.show([], this.filter);
        });
      } else {
        this.$message.error("未存在需要导出的数据");
      }
    },
    modifyStyle() {
      this.$nextTick(() => {
        this.$refs._photoExamineStyleDialog.show();
      });
    },
    examineAlumniPhoto(log_ids, is_poss) {
      this.$api
        .examineAlumniPhoto({
          token: localStorage.getItem("token"),
          log_ids: log_ids,
          is_poss: is_poss,
        })
        .then(({ data }) => {
          this.getList();
        })
        .catch(({ error }) => {});
    },
    // 下载
    download(row) {
      this.$nextTick(() => {
        this.$refs._exportUserPhotoDialog.show([row.log_id]);
      });
    },
    // 排序
    changeTableSort(column) {
      let order = StrUtils.getPropOrder(column);
      this.getList(order);
    },
    // 将输入结果存储到查询参数中
    $query() {
      this.filter = JSON.parse(JSON.stringify(this.inputing));
      this.getList();
    },
    // 将输入结果,查询参数重置
    $reset() {
      this.inputing = { where_name: "", where_student_no: "" };
      this.filter = { where_name: "", where_student_no: "" };
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  // background-color: #ffffff;
  border-radius: 5px;
  // padding-bottom: 58px;
}
.mainbody .title {
  cursor: pointer;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-right: 20px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  background-color: #ffffff;
  box-sizing: border-box;
  // margin-top: 24px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 32px;
  overflow: hidden; /*溢出的部分隐藏*/
}
.elTabs .is-top {
  margin-bottom: 15px;
}
.filter {
  padding: 23px 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #595959;
}
.filter .wrap {
  display: flex;
  flex: 1;
  margin-right: 20px;
  align-items: center;
}
.filter .wrap .el-input {
  width: 65%;
}
</style>


// WEBPACK FOOTER //
// src/components/photoExamine/photoExamineList.vue